import { Col as StylistCol } from 'stylist'
import styled from '@emotion/styled'

export const Col = styled(StylistCol)`
  word-break: break-word;
  display: flex;
  flex-direction: column;
`

export const CenteredCol = styled(Col)`
  text-align: center;
  align-items: center;
  justify-content: center;
`

export const GrowCol = styled(Col)`
  justify-content: center;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/Col.js